import { ValidateAddressErrorCodes } from 'pages/NewCart/constants/errorCode.constants';

export const isInvalidAddress = (errorCode: string): boolean => {
  const errorCodes: string[] = [ValidateAddressErrorCodes.BS102, ValidateAddressErrorCodes.BS103];
  return errorCodes.indexOf(errorCode) > -1;
};
